import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, AlertTriangle } from "lucide-react";

export default function ConfermaOpzione() {
  const { bookingId, token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    api.get(`/bookings/${bookingId}/accept/${token}`)
      .then((r) => setInfo(r.data))
      .catch((e) => setError(e?.response?.data?.detail || "Link non valido"));
  }, [bookingId, token]);

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/bookings/${bookingId}/accept/${token}`);
      setDone(data);
    } catch (e) { setError(e?.response?.data?.detail || "Errore nella conferma"); } finally { setBusy(false); }
  };

  const eur = (n) => `€ ${Number(n || 0).toFixed(2)}`;

  return (
    <Layout>
      <section className="max-w-[760px] mx-auto px-6 lg:px-10 py-24 text-center" data-testid="accept-page">
        {error && (
          <div data-testid="accept-error">
            <AlertTriangle size={48} className="mx-auto text-[#8C3A27]" />
            <h1 className="font-display text-4xl mt-6">Impossibile procedere</h1>
            <p className="mt-4 text-[#6B6960]">{error}</p>
            <Link to="/contatti" className="inline-block mt-8 underline">Contatta la segreteria</Link>
          </div>
        )}
        {!error && !info && <div className="text-[#6B6960]">Caricamento…</div>}
        {!error && info && (done || info.status === "confirmed") && (
          <div data-testid="accept-success">
            <CheckCircle2 size={56} className="mx-auto text-[#8C3A27]" />
            <div className="overline mt-6">Prenotazione confermata</div>
            <h1 className="font-display text-5xl mt-3">Grazie, {info.contact_first_name}!</h1>
            <p className="mt-6 text-[#6B6960]">
              {done?.already || info.status === "confirmed" && !done ? "Questa opzione risulta già confermata." : "La sua opzione è stata accettata e la segreteria è stata avvisata."}
              {" "}Riferimento <strong>{info.reference}</strong>. Riceverà a breve il modulo per la registrazione degli ospiti.
            </p>
            <Button onClick={() => window.location.assign("/")} className="btn-primary-cdm rounded-full h-11 px-7 mt-10">Torna alla home</Button>
          </div>
        )}
        {!error && info && !done && info.status !== "confirmed" && (
          <div data-testid="accept-form">
            <div className="overline">Conferma opzione</div>
            <h1 className="font-display text-5xl mt-3">Accetta il preventivo</h1>
            <div className="mt-10 border border-[#E2DFD6] bg-white p-8 text-left inline-block min-w-[320px]">
              <div className="overline">Riferimento</div>
              <div className="font-display text-2xl">{info.reference}</div>
              <div className="mt-4 text-sm space-y-1 text-[#1A1A1A]">
                {info.organization && <div>Gruppo: <strong>{info.organization}</strong></div>}
                <div>Soggiorno: {info.check_in} → {info.check_out} · {info.num_participants} partecipanti</div>
                <div>Pacchetto: <strong>{info.package_label}</strong></div>
              </div>
              <div className="mt-4 flex justify-between items-baseline border-t border-[#E2DFD6] pt-4">
                <span className="overline">Totale</span>
                <span className="font-display text-3xl text-[#8C3A27]" data-testid="accept-total">{eur(info.total)}</span>
              </div>
            </div>
            <div className="mt-10">
              <Button onClick={accept} disabled={busy} className="btn-primary-cdm rounded-full h-12 px-8 text-base" data-testid="accept-btn">
                {busy ? "Confermo…" : "Accetto l'opzione"}
              </Button>
              <p className="text-xs text-[#6B6960] mt-4">Il pagamento avviene in loco. Cliccando confermi la prenotazione e la segreteria verrà avvisata.</p>
            </div>
          </div>
        )}
      </section>
    </Layout>
  );
}
